(function () {
  var root = document.documentElement;
  var body = document.body;
  if (!root) return;

  var config = window.milanoThemeTokens || {};
  var storageKey = 'milano-theme';
  var defaultTheme = config.defaultTheme === 'dark' ? 'dark' : 'light';

  function applyTheme(theme) {
    var next = theme === 'dark' ? 'dark' : 'light';
    root.setAttribute('data-theme', next);
    if (body) {
      body.setAttribute('data-theme', next);
      body.classList.toggle('is-dark-theme', next === 'dark');
      body.classList.toggle('is-light-theme', next !== 'dark');
    }
    var toggle = document.querySelector('[data-theme-toggle]');
    if (toggle) {
      toggle.setAttribute('aria-pressed', next === 'dark' ? 'true' : 'false');
      toggle.dataset.theme = next;
    }
  }

  function getStoredTheme() {
    try {
      return window.localStorage.getItem(storageKey);
    } catch (e) {
      return null;
    }
  }

  function setStoredTheme(theme) {
    try {
      window.localStorage.setItem(storageKey, theme);
    } catch (e) {}
  }

  applyTheme(getStoredTheme() || defaultTheme);

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-theme-toggle]');
    if (!button) return;
    var current = root.getAttribute('data-theme') === 'dark' ? 'dark' : 'light';
    var next = current === 'dark' ? 'light' : 'dark';
    applyTheme(next);
    setStoredTheme(next);
  });
})();
